import React from 'react'
import { milisToMiliseconds, mmSSFormat } from '../utils/util'
import AudioBar from './AudioBar'
import PlayIcon from '../svg/PlayIcon'
import PauseIcon from '../svg/PauseIcon'
import '../styles/AudioPlayer.css'
import i18n from '../i18n'

export default function AudioPlayer(props) {
    const { playSound, currentTime, pauseSound, soundStatus, duration, audioBars } = props
    const barDuration = duration / audioBars.length
    const currentBar = Math.floor((currentTime * 1000) / barDuration)
    const currentTimeMs = mmSSFormat(currentTime)
    const durationMs = milisToMiliseconds(duration)

    const soundPlayable = ['idle', 'paused', 'finished', 'canceled'].includes(soundStatus)

    const drawAudioBars = () => {
        return audioBars.map((el, index) => {
            let isPlaying = false

            if (soundStatus != 'idle' && currentBar == index) isPlaying = true

            return <AudioBar isPlaying={isPlaying} duration={barDuration} key={index} currentTime={currentTime} height={el} />
        })
    }

    const handleClickAudioControl = () => (soundPlayable ? playSound() : pauseSound())

    return (
        <div className="issue-solution-full-audio">
            <div className="audio-player-controls" style={i18n.language === 'ar' ? { marginLeft: 14, marginRight: 0 } : {}}>
                <div className="circle-34 bg-black fully-centered" onClick={handleClickAudioControl}>
                    {soundPlayable ? <PlayIcon style={{ marginLeft: 2 }} /> : <PauseIcon style={{ marginLeft: 2 }} />}
                </div>
            </div>
            <div className="audio-player-bars-and-time">
                <div className="audio-player-bars">{drawAudioBars()}</div>
                <div className="audio-player-times">
                    <div>{soundStatus !== 'idle' ? <span>{currentTimeMs}</span> : <span>{durationMs}</span>}</div>
                </div>
            </div>
        </div>
    )
}
